// extracted by mini-css-extract-plugin
export default {"tableContainer":"customTable_tableContainer__4TV2p","rowHeaders":"customTable_rowHeaders__XUfj1","row":"customTable_row__hXlP9"};